export default __webpack_public_path__ + "static/media/bg-triangle.c0c30b56.svg";